import { AjaxContext, formatListData } from 'commons-ui';
import { IApp, IPermission } from 'models/settingsV2.model';
import { useCallback, useContext } from 'react';
import { SERVICE_NAMES } from '../../../../../settingsV2Enum';
import { permissionUrlPrefix, RESOURCES, SETTINGS_V2_ACTION } from '../../../../../settingsV2Constant';
import { IPermissionsSetData } from './listConfig';

const useService = (permissionsSetAllDetails: IPermissionsSetData) => {
	const { postData } = useContext(AjaxContext);
	const { permissionIds } = permissionsSetAllDetails;
	const permissionIdsLength: number = permissionIds ? permissionIds.length : 0;
	const getPermissionsSetDetails = useCallback(async ({ app }: { app: IApp }) => {
		const res = await postData({
			endpoint: `${permissionUrlPrefix}-getPermissions`,
			body: {
				permissionIds,
				forwardReqRoute: `/dashboard/${RESOURCES.permission}/${SETTINGS_V2_ACTION.getPermissions}`,
				forwardReqToService: SERVICE_NAMES.AUTH
			},
			queryParams: {
				appName: app.appName
			}
		});
		const listData: Array<IPermission> = formatListData(res?.data?.data);
		return { rowCount: permissionIdsLength, data: listData };
	}, []);

	return {
		getPermissionsSetDetails
	};
};

export default useService;
